import {Component, Input, OnInit} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../services/auth.service";
import {Testbed} from "../../../model/testbed";
import {TestbedsService} from "../../../services/testbeds.service";
import {User} from "../../../model/user";

@Component({
  selector: 'aw-testbed-card',
  templateUrl: './testbed-card-dashboard.html',
  styleUrls: ['./testbed-card-dashboard.scss']
})
export class TestbedCardDashboard implements OnInit {

  testbed?: Testbed;
  loading = false;
  loggedUser: User;

  constructor(
    public dialog: MatDialog,
    public testbedService: TestbedsService,
    public authService: AuthService,
  ) {
  }

  @Input() set element(element: Testbed) {
    this.testbed = element;
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
  }

}
